import { isClient } from '~utils/isClient'

/**
 * Returns true if apple payments available
 */
export const getIsApplePaymentsAvailable = () => {
    let CAN_MAKE_APPLE_PAYMENTS = false

    if (isClient()) {
        try {
            CAN_MAKE_APPLE_PAYMENTS = window?.ApplePaySession?.canMakePayments?.() || false
        } catch {
            CAN_MAKE_APPLE_PAYMENTS = false
        }
    }

    return CAN_MAKE_APPLE_PAYMENTS
}
